module.exports = "img/photo11.06c41e.jpeg";